export const linkStyles = {
  style: { marginInlineStart: 0 },
};

export const buttonStyles = {
  w: { base: 12, md: 14 },
  h: { base: 8, md: 10 },
  bg: "primary.500",
  _hover: { bg: "primary.600" },
  _active: { bg: "primary.700" },
};

export const iconStyles = {
  w: { base: 4, md: 6 },
  h: { base: 4, md: 6 },
  color: "white",
};
